import { render, staticRenderFns } from "./StatusCadastros.vue?vue&type=template&id=2ee84688&"
import script from "./StatusCadastros.vue?vue&type=script&lang=js&"
export * from "./StatusCadastros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports